
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import {
  AgentResource,
  AgentSettingResource
} from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";
import router from "@/router";

const systemModule = getModule(SystemModule);

@Component
export default class ManageSettings extends Vue {
  @Prop()
  public agent:AgentResource;
    
  @Prop()
  public agentSettings: Array<AgentSettingResource>;

    filterString:string='';

  loading: boolean = false;
  loadingPage: boolean = false;
 

  agentSetting: AgentSettingResource = {
    id: null,
    agentId: null,
    settingName: null,
    settingValue: null
  };

  isSettingModalVisible: boolean = false;
  isDeleteSettingModalVisible: boolean = false;

  async addAgentSetting() {
    this.agentSetting = {
      id: null,
      agentId: this.agent.id,
      settingName: null,
      settingValue: null
    };

    this.isSettingModalVisible = true;
  }

  async editAgentSetting(id: number) {
    let clone = this.agentSettings.find(x => x.id === id);
    clone = { ...clone };

    this.agentSetting = clone;
    this.isSettingModalVisible = true;
  }

  async saveAgentSetting() {
    try {
      this.agentSetting.agentId = this.agent.id;
      if (this.agentSetting.id === null) {
        await systemModule.postAgentSetting(this.agentSetting);
      } else {
        await systemModule.putAgentSetting(this.agentSetting);
      }
      notifications.success("Success", `Setting saved.`);
    } catch (error) {
      notifications.error("Save Failed", "Unable to save setting.", error);
    }
    this.$emit("updated");
  }

  showAgentSettingDeleteConfirmation(id: number) {
    let clone = this.agentSettings.find(x => x.id === id);
    clone = { ...clone };

    this.agentSetting = clone;
    this.isDeleteSettingModalVisible = true;
  }

  async deleteAgentSetting() {
    try {
      await systemModule.deleteAgentSetting(this.agentSetting.id);
      this.$emit("updated");
      notifications.success("Success", `Setting deleted.`);
    } catch (error) {
      notifications.error("Delete Failed", "Unable to delete setting.", error);
    }
  }

  done() {
    router.push(`/admin/agents`);
  }
}
